// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationSearchFormStyles } from "@guestsupply/Overrides/Components/LocationSearchForm";
import { color, styledScrollbar, xScreen } from "@guestsupply/XDL/Utilities";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";


locationSearchFormStyles.centeringWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
    `,
};

locationSearchFormStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

locationSearchFormStyles.form = {
    css: css`
        width: 100%;
    `,
};

locationSearchFormStyles.searchButtonGridItem = {
    width: [12, 12, 12, 12, 3],
    css: css`
        padding-top: 10px;
        display: inline-block;
        width: 100%;
        flex-direction: row;
        text-align: right;
        align-self: flex-end;
        & > div {
            display: inline-flex;
        }
    `,
};

locationSearchFormStyles.searchResultsText = {
    css: css`
        margin-top: 10px;
    `,
};

locationSearchFormStyles.searchResultsTextGridItem = {
    width: 4,
};

locationSearchFormStyles.distanceUnitOfMeasureGridItem = {
    width: 8,
    align: "middle",
};

locationSearchFormStyles.distanceUnitOfMeasureRadioGroup = {
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        text-align: right;
        & > div {
            display: inline-flex;
        }
    `,
};

locationSearchFormStyles.siteMessageGeocodeErrorText = {
    color: "danger",
    weight: "bold",
};

locationSearchFormStyles.siteMessageResultsErrorText = {
    color: "danger",
    weight: "bold",
};

locationSearchFormStyles.searchResultGridItem = {
    width: 12,
};

locationSearchFormStyles.searchResultLocationDetailsGridContainer = {
    gap: 10,
};

locationSearchFormStyles.searchResultDisplayNumberGridItem = {
    width: 1,
    css: css`
        justify-content: center;
    `,
};

locationSearchFormStyles.locationNameText = {
    color: "primary",
    weight: "bold",
    ellipsis: true,
};

locationSearchFormStyles.searchResultAddressInfoOffsetGridItem = {
    width: 1,
    css: css`
        justify-content: center;
    `,
};

locationSearchFormStyles.searchResultPhoneOffsetGridItem = {
    width: 1,
};

locationSearchFormStyles.searchResultPhoneGridItem = {
    width: [11, 11, 11, 11, 3],
};

locationSearchFormStyles.searchResultLinksAndDistanceContainer = {
    gap: 0,
    css: css`
        width: 100%;
        padding: 0;
        margin: 0;
    `,
};

locationSearchFormStyles.searchResultLinksOffsetGridItem = {
    width: [1, 1, 1, 1, 0],
};

locationSearchFormStyles.searchResultContentGridItem = {
    width: 2,
};

locationSearchFormStyles.searchResultDividerGridItem = {
    width: 12,
};

locationSearchFormStyles.searchResultDivider = {
    css: css`
        margin: 24px 0;
        border: 1px solid rgba(74, 74, 74, 0.2);
        width: 100%;
    `,
};

locationSearchFormStyles.pagination = {
    cssOverrides: {
        pagination: css`
            justify-content: center;
        `,
        perPageSelect: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ],
                    "min",
                )}
        `,
    },
};

locationSearchFormStyles.searchContainer = {
    css: css`
        display: grid;
    `,
};

locationSearchFormStyles.searchInputGridContainer = {
    gap: 25,
    offsetCss: css`
        padding: 10px 20px;
        justify-content: flex-end;
    `,
};

locationSearchFormStyles.searchGeoLocationGridItem = {
    width: [12, 12, 12, 4, 4],
};

locationSearchFormStyles.searchLocationsGridItem = {
    width: [12, 12, 12, 4, 4],
};

locationSearchFormStyles.searchRadiusGridItem = {
    width: [12, 12, 12, 4, 4],
};

locationSearchFormStyles.searchButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

locationSearchFormStyles.clearButton = {
    variant: "tertiary",
    css: css`
        margin-left: 10px;
        ${xScreen("lte", "xs")} {
            margin-left: 0;
            margin-top: 10px;
            width: 100%;
        }
    `,
};

locationSearchFormStyles.siteMessageGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-top: 20px;
        }
    `,
};

locationSearchFormStyles.searchResultRow = {
    css: css`
        overflow-y: auto;
        overflow-x: hidden;
        height: 642px;
        border: 1px solid ${color("common.border")};
        ${styledScrollbar()}
        ${xScreen("lte", "md")} {
            height: auto;
            min-height: 150px;
            max-height: 642px;
        }
    `,
};

locationSearchFormStyles.searchResultGridContainer = {
    gap: 0,
    offsetCss: css`
        padding: 10px 20px;
    `,
};

locationSearchFormStyles.locationDisplayNumberText = {
    color: "text",
    weight: "bold",
    css: css`
        &::after {
            content: ".";
        }
    `,
};

locationSearchFormStyles.searchResultLocationGridItem = {
    width: 11,
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.locationNameLink = {
    color: "text",
    typographyProps: {
        size: 16,
        weight: "bold",
        ellipsis: true,
    },
};

locationSearchFormStyles.searchResultAddressInfoGridItem = {
    width: 11,
    css: css`
        padding: 10px 0;
    `,
};

locationSearchFormStyles.searchResultPhoneLink = {
    typographyProps: {
        css: css`
            &&& {
                color: ${color("text")};
            }
        `,
    },
};

locationSearchFormStyles.locationGoogleMapsDirectionLink = {
    typographyProps: {
        css: css`
            &&& {
                color: ${color("text")};
            }
        `,
    },
};

locationSearchFormStyles.locationContentLink = {
    typographyProps: {
        css: css`
            &&& {
                color: ${color("text")};
            }
        `,
    },
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: 11,
    css: css`
        padding: 5px 0;
        flex-wrap: wrap;
        justify-content: space-between;
    `,
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    width: 11,
};

locationSearchFormStyles.accordionSection = {
    headerProps: {
        css: css`
            border: 1px solid ${color("common.border")};
            & > button, & > button:focus {
                border-top: none !important;
            }
        `,
    },
    panelProps: {
        css: css`
            margin: 0;
            border: 1px solid ${color("common.border")};
        `,
    },
};
